import '../css/login.scss';
import { createElement, Popup, utility } from 'ui-cjs';
import { loginSteps, errorCodes, query, queryAll, encrypt, delay } from './helper.js';

//var init = utility.init;
//var r = utility.r;
var r = (_, text) => text;

const { domLoad, post, nullOrEmpty, isEmail, verifyPassword, setCookie } = utility;

var checkedUser;
var token;
var forgotPassword;

function loading(flag) {
    query('#input-email').disabled = flag;
    query('#input-password').disabled = flag;
    queryAll('.login-button').forEach(b => b.disabled = flag);
    query('#login-forgot-link').classList[flag ? 'add' : 'remove']('disabled');
    query('#forgot-email').disabled = flag;
    query('#forgot-submit-button').disabled = flag;
    query('#verify-code').disabled = flag;
    query('#new-password').disabled = flag;
    query('#confirm-password').disabled = flag;
    query('#password-continue-button').disabled = flag;
};

function getErrorMessage(code) {
    switch (code) {
        case errorCodes.badParameter:
        case errorCodes.invalidUsernameOrPassword: return r('P_LOGIN_INVALIDUSERNAMEORPASSWORD', 'Invalid username or password.');
        case errorCodes.inactiveUser: return r('P_LOGIN_USERACCOUNTISNOTCURRENTLYACTIVE', 'User account is not currently active.');
        case errorCodes.lockedUser: return r('P_LOGIN_THEUSERWASLOCKED', 'The user was locked.');
        case errorCodes.passwordExpired: return r('P_LOGIN_PASSWORDHASEXPIRED', 'Password has expired.');
        case errorCodes.haveNoPermission: return r('P_LOGIN_THEUSERDOESNOTHAVEPERMISSION', 'The user does not have permission');
        case errorCodes.invalidToken: return r('P_LOGIN_INVALIDAUTHENTICATETOKEN', 'Invalid authenticate token.');
        case errorCodes.invalidVerifyCode: return r('P_LOGIN_INVALIDVERIFYCODE', 'The verify code is invalid.');
        case errorCodes.passwordNotStrong: return r('PASSWORDNOTSTRONG', 'A password must contain at least 8 characters with a mix of uppercase letters, lowercase letters and numbers.');
        default: return r('P_LOGIN_UNKNOWNERROROCCURRED', 'Unknown error occurred.');
    }
}

function showError(id, error) {
    if (error instanceof TypeError) {
        //error = error.message;
        error = null;
    }
    query(id).innerText = error || r('P_LOGIN_UNKNOWNERROROCCURRED', 'Unknown error occurred.');
    query(id).style.display = '';
}

function setClientTimeoffset() {
    var host = location.hostname;
    host = host.substring(host.indexOf('.'));
    var offset = new Date().getTimezoneOffset();
    setCookie('clienttimeoffset', offset, 360, host);
}

setClientTimeoffset();
domLoad().then(() => {
    queryAll('[data-lgid]').forEach(t => t.dataset.lgid = '');
    // 检测是否包含错误
    if (apiResults != null) {
        executeLoginResult(apiResults);
    } else {
        // 初始化页面
        var currentId = localStorage.getItem('current_user_id');
        if (currentId) {
            query('#input-email').value = currentId;
            query('#login-button-next').focus();
        } else {
            query('#input-email').focus();
        }
    }

    bindEvents();
});


function apiPost(url, data) {
    return post(url, data, { diagnostic: true }).then(async result => {
        var delays = 1000 - result.time;
        if (!isNaN(delays) && delays > 0) {
            await delay(delays);
        }
        var resp = result.response;
        if (!resp.ok) {
            throw new Error(r('P_SERVER_UNKNOWNERROR', 'An unknown error has occurred on the server.'));
        }
        return resp.json();
    });
}

function showTermOfUse(result) {
    var popup = new Popup({
        title: r('TERMS', 'Terms of Use'),
        closable: false,
        movable: false,
        resizable: false,
        content: createElement('iframe', iframe => iframe.src = result.termOfUse.url),
        buttons: [
            {
                text: r('ACCEPTTERM', 'Accept and continue'),
                className: 'primary-button',
                trigger: () => {
                    apiPost('api/accept', {
                        userIID: result.session.user.uid,
                        termId: result.termOfUse.id
                    }).then(data => {
                        if (data.errorCode === 0) {
                            enterSystem(result);
                        } else {
                            showError('#error-message', getErrorMessage(data.errorCode, data.errorMessage));
                            loading(false);
                        }
                    }).catch(e => {
                        showError('#error-message', e);
                        loading(false);
                        query('#input-password').focus();
                    });
                }
            },
            {
                text: r('DISAGREE', 'Disagree'),
                trigger: () => loading(false)
            }
        ]
    });

    popup.show().then(mask => mask.classList.add('term-of-use'));
}

function changePage(from, to, focus, back) {
    clearErrorMessage(to);
    query(from).style.display = 'none';

    const c = back ? 'hidden-left' : 'hidden';
    to = query(to);
    to.classList.add(c);
    to.style.display = '';
    setTimeout(() => to.classList.remove(c), 10);

    if (focus != null) {
        setTimeout(() => query(focus).focus(), 110);
    }
}

function clearErrorMessage(panel) {
    query(panel).querySelectorAll('.login-message').forEach(e => e.style.display = 'none');
}

function executeLoginResult(data, userId) {
    var labelError, labelFocus;
    if (query('#login-panel-password').style.display === 'none') {
        labelError = '#error-email-message';
        labelFocus = '#input-email';
    } else {
        labelError = '#error-message';
        labelFocus = '#input-password';
    }

    if (data.errorCode === 0 && data.result != null) {
        token = data.result.token;
        forgotPassword = false;
        // login success
        if (!nullOrEmpty(userId)) {
            localStorage.setItem('current_user_id', userId);
        }
        query('#verify-code').value = '';
        query('#new-password').value = '';
        query('#confirm-password').value = '';
        switch (data.result.nextStep) {
            case loginSteps.returnToLoginPage:
                window.location = consts?.path || '/';
                break;

            case loginSteps.inputVerifyCode:
                loading(false);
                query('#verify-code-item').style.display = '';
                queryAll('.password-item').forEach(it => it.style.display = 'none');
                changePage('#login-panel', '#change-password-panel', '#verify-code');
                break;

            case loginSteps.inputNewPasswordAndVerifyCode:
                loading(false);
                query('#verify-code-item').style.display = '';
                queryAll('.password-item').forEach(it => it.style.display = '');
                changePage('#login-panel', '#change-password-panel', '#verify-code');
                break;

            case loginSteps.inputNewPassword:
                loading(false);
                query('#verify-code-item').style.display = 'none';
                queryAll('.password-item').forEach(it => it.style.display = '');
                changePage('#login-panel', '#change-password-panel', '#new-password');
                break;

            case loginSteps.enterSystem:
                if (data.result.termOfUse != null) {
                    showTermOfUse(data.result);
                } else {
                    enterSystem(data.result);
                }
                break;

            default:
                loading(false);
                showError(labelError);
                query(labelFocus).focus();
                break;
        }
    } else {
        showError(labelError, getErrorMessage(data.errorCode, data.errorMessage));
        loading(false);
        query(labelFocus).focus();
    }
}

function bindEvents() {
    queryAll('input[data-submit]').forEach(input => {
        input.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                var target = input.dataset.submit;
                query('#' + target)?.dispatchEvent(new Event('click'));
            }
        });
    });

    // forgot link
    query('#login-forgot-link').addEventListener('click', function (e) {
        e.preventDefault();
        if (this.classList.contains('disabled')) {
            return;
        }
        query('#forgot-email').value = query('#input-email').value;
        changePage('#login-panel', '#forgot-password-panel', '#forgot-email');
    });

    // forgot back button
    query('#forgot-back-button').addEventListener('click', () => {
        changePage('#forgot-password-panel', '#login-panel', checkedUser == null ? '#input-email' : '#input-password', true);
    });

    // forgot submit button
    query('#forgot-submit-button').addEventListener('click', () => {
        var userId = query('#forgot-email').value;
        if (!isEmail(userId)) {
            showError('#forgot-error-message', r('P_IPT_VALIDEMAILADDRESSFORMATREQUIRED', 'Valid email address format required.'));
            query('#forgot-email').focus();
            return;
        }
        clearErrorMessage('#forgot-password-panel');
        loading(true);
        apiPost('api/forgot', JSON.stringify(userId)).then(data => {
            loading(false);
            if (data.errorCode === 0 && data.result != null) {
                token = data.result.token;
                forgotPassword = true;
                query('#verify-code-item').style.display = '';
                queryAll('.password-item').forEach(it => it.style.display = 'none');
                query('#verify-code').value = '';
                query('#new-password').value = '';
                query('#confirm-password').value = '';
                changePage('#forgot-password-panel', '#change-password-panel', '#verify-code');
            } else {
                showError('#forgot-error-message', getErrorMessage(data.errorCode, data.errorMessage));
                query('#forgot-email').focus();
            }
        }).catch(e => {
            showError('#forgot-error-message', e);
            loading(false);
            query('#forgot-email').focus();
        });
    });

    // password sent back link
    query('#password-sent-back-link').addEventListener('click', e => {
        e.preventDefault();
        query('#input-email').value = query('#forgot-email').value;
        query('#input-password').value = '';
        changePage('#password-sent-panel', '#login-panel', checkedUser == null ? '#input-email' : '#input-password', true);
    });

    // login back icon
    query('#icon-login-back').addEventListener('click', () => {
        checkedUser = null;
        query('#login-panel-email').style.display = '';
        query('#login-panel-email-readonly').style.display = 'none';
        query('#login-panel-password').style.display = 'none';
        query('#login-panel-forgot-link').style.display = '';
        query('#input-password').value = '';
        query('.login-azure-function').style.display = 'none';
        query('#login-button-next').style.display = '';
        clearErrorMessage('#login-panel');

        query('#login-panel-email').focus();
    });

    // login sso button
    query('#login-azure-button').addEventListener('click', () => {
        if (checkedUser?.supportAzureSSO !== true) {
            // not supportted
            return;
        }
        var organizationId = checkedUser.organizationId;
        var userId = checkedUser.azureAccountName;
        if (nullOrEmpty(userId)) {
            userId = query('#input-email').value;
        }
        loading(true);
        var focusId = checkedUser.accountSupportLocalAuthenticate ? '#input-password' : '#input-email';
        var urlParams = new URLSearchParams(location.search);
        apiPost('api/azure_login', {
            companyId: organizationId,
            userId,
            url: urlParams.get('f')
        }).then(data => {
            // TODO: debug
            console.log(data);
            var url = data.result?.url;
            if (nullOrEmpty(url)) {
                loading(false);
                showError('#error-message', getErrorMessage(data.errorCode, data.errorMessage));
                query(focusId).focus();
            } else {
                window.location = url;
            }
        }).catch(e => {
            showError('#error-message', e);
            loading(false);
            query(focusId).focus();
        });
    });

    // user next button
    query('#login-button-next').addEventListener('click', () => {
        var userId = query('#input-email').value;
        if (nullOrEmpty(userId)) {
            showError('#error-email-message', r('REQUIREDUSERNAME', 'User name is required.'));
            query('#input-email').focus();
            return;
        }

        clearErrorMessage('#login-panel');
        loading(true);
        apiPost('api/check_account', { userId }).then(data => {
            if (data.errorCode === 0) {
                var result = data.result;
                if (result == null || (!result.supportAzureSSO && !result.supportFleetAuthenticate)) {
                    showError('#error-email-message', getErrorMessage(errorCodes.invalidUsernameOrPassword));
                    loading(false);
                    query('#input-email').focus();
                    return;
                }

                var sso = result.supportAzureSSO;
                var local = result.supportFleetAuthenticate;

                if (sso && !local) {
                    // 不允许本地登录的话直接跳转到 sso 认证页面
                    var organizationId = result.organizationId;
                    var urlParams = new URLSearchParams(location.search);
                    apiPost('api/azure_login', {
                        companyId: organizationId,
                        userId,
                        url: urlParams.get('f')
                    }).then(data => {
                        // TODO: debug
                        console.log(data);
                        var url = data.result?.url;
                        if (nullOrEmpty(url)) {
                            loading(false);
                            showError('#error-email-message', getErrorMessage(data.errorCode, data.errorMessage));
                            query('#input-email').focus();
                        } else {
                            window.location = url;
                        }
                    }).catch(e => {
                        showError('#error-email-message', e);
                        loading(false);
                        query('#input-email').focus();
                    });
                } else {
                    loading(false);
                    query('#label-input-email').innerText = userId;
                    query('#login-panel-email').style.display = 'none';
                    query('#login-panel-email-readonly').style.display = '';
                    query('#login-button-next').style.display = 'none';
                    if (local) {
                        // 显示密码
                        query('#login-panel-password').style.display = '';
                        query('#login-panel-forgot-link').style.display = '';
                        query('#input-password').focus();
                    } else {
                        // 不允许本地登录
                        query('#login-panel-password').style.display = 'none';
                        query('#login-panel-forgot-link').style.display = 'none';
                    }
                    if (sso) {
                        query('#login-azure-label').style.display = local ? '' : 'none';
                        query('.login-azure-function').style.display = '';
                    } else {
                        query('.login-azure-function').style.display = 'none';
                    }
                }
                checkedUser = result;
            } else {
                showError('#error-email-message', getErrorMessage(data.errorCode, data.errorMessage));
                loading(false);
                query('#input-email').focus();
            }
        }).catch(e => {
            showError('#error-email-message', e);
            loading(false);
            query('#input-email').focus();
        });
    });

    // login button
    query('#login-button-login').addEventListener('click', () => {
        var userId = query('#input-email').value;
        if (nullOrEmpty(userId)) {
            showError('#error-email-message', r('REQUIREDUSERNAME', 'User name is required.'));
            query('#input-email').focus();
            return;
        }

        clearErrorMessage('#login-panel');
        var password = query('#input-password').value;
        if (nullOrEmpty(password)) {
            showError('#error-message', r('P_IPT_PASSWORDISREQUIRED', 'Password is required.'));
            query('#input-password').focus();
            return;
        }
        loading(true);
        encrypt(password).then(buffer => {
            return apiPost('api/login', {
                userId: userId,
                password: buffer // btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
            }).then(data => executeLoginResult(data, userId));
        }).catch(e => {
            showError('#error-message', e);
            loading(false);
            query('#input-password').focus();
        });
    });

    // password back button
    query('#password-back-button').addEventListener('click', () => {
        if (forgotPassword) {
            changePage('#change-password-panel', '#forgot-password-panel', '#forgot-email', true);
        } else {
            changePage('#change-password-panel', '#login-panel', checkedUser == null ? '#input-email' : '#input-password', true);
        }
    });

    // password continue button
    query('#password-continue-button').addEventListener('click', () => {
        var verifyCode = query('#verify-code').value;
        if (query('#verify-code-item').style.display !== 'none') {
            if (nullOrEmpty(verifyCode)) {
                showError('#password-error-message', r('P_LOGIN_VERIFYCODEREQUIRED', 'Verify code is required.'));
                query('#verify-code').focus();
                return;
            }
        }
        var password = query('#new-password').value;
        if (query('.password-item').style.display !== 'none') {
            if (nullOrEmpty(password)) {
                showError('#password-error-message', r('P_IPT_PASSWORDISREQUIRED', 'Password is required.'));
                query('#new-password').focus();
                return;
            }
            if (!verifyPassword(password)) {
                showError('#password-error-message', getErrorMessage(errorCodes.passwordNotStrong));
                query('#new-password').focus();
                return;
            }
            if (query('#confirm-password').value !== password) {
                showError('#password-error-message', r('P_IPT_THEPASSWORDSYOUENTEREDDONOTMATCHCHECKYOURTYPINGANDTRYAGAIN', 'The passwords you entered do not match. Check your typing and try again.'));
                query('#confirm-password').focus();
                return;
            }
        }
        clearErrorMessage('#change-password-panel');
        loading(true);
        if (forgotPassword) {
            verifyForgot(token, verifyCode);
        } else {
            verifyLogin(token, password, verifyCode);
        }
    });

    query('#term-of-use-link').addEventListener('click', e => {
        e.preventDefault();
        var popup = new Popup({
            title: r('TERMS', 'Terms of Use'),
            closable: false,
            movable: false,
            resizable: false,
            content: createElement('iframe', iframe => iframe.src = (consts?.path || '') + 'termofuse.html'),
            buttons: [
                {
                    text: r('P_MAIN_CLOSE', 'Close')
                }
            ]
        });

        var mask = popup.create();
        mask.classList.add('term-of-use');
        popup.show();
    });
}

function verifyForgot(token, verifyCode) {
    apiPost('api/verify_forgot', {
        token,
        verifyCode
    }).then(data => {
        if (data.errorCode === 0 && data.result != null) {
            // forgot email sent
            loading(false);
            changePage('#change-password-panel', '#password-sent-panel', '#password-sent-back-link');
        } else {
            showError('#password-error-message', getErrorMessage(data.errorCode, data.errorMessage));
            loading(false);
            query('#verify-code').focus();
        }
    }).catch(e => {
        showError('#password-error-message', e);
        loading(false);
        query('#verify-code').focus();
    });
}

function verifyLogin(token, password, verifyCode) {
    encrypt(password).then(buffer => {
        return apiPost('api/verify', {
            token,
            newPassword: buffer, // btoa(String.fromCharCode.apply(null, new Uint8Array(buffer))),
            verifyCode
        }).then(data => {
            if (data.errorCode === 0 && data.result != null) {
                // login success
                switch (data.result.nextStep) {
                    case loginSteps.returnToLoginPage:
                        window.location = consts?.path || '/';
                        break;

                    case loginSteps.enterSystem:
                        if (data.result.termOfUse != null) {
                            showTermOfUse(data.result);
                        } else {
                            enterSystem(data.result);
                        }
                        break;

                    default:
                        showError('#password-error-message');
                        loading(false);
                        query('#new-password').focus();
                        break;
                }
            } else {
                showError('#password-error-message', getErrorMessage(data.errorCode, data.errorMessage));
                loading(false);
                if (query('.password-item').style.display !== 'none') {
                    query('#confirm-password').focus();
                } else {
                    query('#verify-code').focus();
                }
            }
        });
    }).catch(e => {
        showError('#password-error-message', e);
        loading(false);
        if (query('.password-item').style.display !== 'none') {
            query('#confirm-password').focus();
        } else {
            query('#verify-code').focus();
        }
    });
}

function enterSystem(result) {
    var host = location.hostname;
    host = host.substring(host.indexOf('.'));
    setCookie(consts.cookie.session, result.session.sessionId, null, host, false);
    setCookie(consts.cookie.lang, result.session.user.displayLanguage, null, host, false);

    if (nullOrEmpty(apiReturnUrl)) {
        window.location = result.nextUrl;
    } else {
        window.location = decodeURIComponent(apiReturnUrl);
    }
}
